import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-best-colleges-ba-digital-marketing-nagpur',
  templateUrl: './best-colleges-ba-digital-marketing-nagpur.component.html',
  styleUrls: ['./best-colleges-ba-digital-marketing-nagpur.component.scss']
})
export class BestCollegesBaDigitalMarketingNagpurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
